import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4110399a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "Dialog-box-sight" }
const _hoisted_2 = { class: "top" }
const _hoisted_3 = { class: "left" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "right" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = { class: "adress" }
const _hoisted_8 = { class: "bottom" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "景点介绍", -1))
const _hoisted_10 = { class: "introudce" }

import { reactive, watch, ref } from 'vue';
import type { SightData } from '@/types/ContentPages/ProductQutation';


export default /*#__PURE__*/_defineComponent({
  __name: 'DialogBoxSight',
  props: {
    data: {}
  },
  setup(__props: any) {

const props = __props;

const BASE_URL = process.env.VUE_APP_PICTURE_URL; // 当地玩乐(景点)BASE_URL

/* eslint-disable */



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("img", {
          src: _unref(BASE_URL) + (props.data?.image1?.includes('sight') ? '' : 'sight/') + props.data?.image1,
          alt: props.data?.cname
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, _toDisplayString(props.data?.cname), 1),
        _createElementVNode("div", _hoisted_7, "景点地址：" + _toDisplayString(props.data?.address), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("div", _hoisted_10, _toDisplayString(props.data?.cbrief), 1)
    ])
  ]))
}
}

})